<template>
  <li class="login-dropdown-wrapper">
    <ul class="dropdown-wrapper">
      <slot name="activator"></slot>
      <transition name="slide">
        <li
          class="login-dropdown position-absolute"
          v-if="dropdown"
          v-click-outside="hide"
        >
          <div class="dropdown-body">
            <slot></slot>
          </div>
        </li>
      </transition>
    </ul>
  </li>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: "LoginDropdown",
  directives: {
    ClickOutside,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    dropdown: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:prop", value);
      },
    },
  },
  mounted() {
    this.popupItem = this.$el;
  },
  methods: {
    hide() {
      this.$emit('hideDropdown', false);
    },
  },
};
</script>

<style lang="scss" scoped>
// Transition for opening and closing the menu
.slide-enter-active {
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -ms-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
.slide-leave-active {
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  -ms-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.slide-enter-to,
.slide-leave {
  max-height: 800px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.login-dropdown-wrapper {
  .dropdown-wrapper {
    list-style-type: none;
    padding: 0;
    .login-dropdown {
      z-index: 2000000001;
      padding: 20px;
      border-left: solid 1px $quaternary;
      border-right: solid 1px $quaternary;
      border-bottom: solid 1px $quaternary;
      border-top: $border-header;
      background-color: $secondary;
      max-width: 346px;
      -webkit-box-shadow: 0px 5px 8px 1px rgba(0, 0, 0, 0.49);
      box-shadow: 0px 5px 8px 1px rgba(0, 0, 0, 0.49);
    }
  }
}
</style>